<template>
  <div class="global-footer-sns-account-block">
    <div class="global-footer-sns-account-inr">
      <p class="global-footer-sns-account-txt">@cosme <span>公式SNSアカウント</span></p>
      <div class="global-footer-sns-icon-area">
        <ul class="global-footer-sns-icon-list">
          <li><a href="https://www.instagram.com/at_cosme/" class="global-footer-sns-icon global-footer-icon-instagram" target="_blank">instagram</a></li>
          <li><a href="https://twitter.com/atcosmenet" class="global-footer-sns-icon global-footer-icon-x" target="_blank">x</a></li>
          <li><a href="https://www.facebook.com/atcosme/" class="global-footer-sns-icon global-footer-icon-facebook" target="_blank">facebook</a></li>
          <li><a href="https://line.me/R/ti/p/%40at_cosme" class="global-footer-sns-icon global-footer-icon-line" target="_blank">line</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sns-account-link',
};
</script>
